<template>
  <!-- NOTIFICATIONS -->
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer" ref="notificationMenu" v-if="loaded">
    <feather-icon icon="BellIcon" class="cursor-pointer ml-4 mr-6 mt-1" :badge="getUnseenNotificationLength" />

    <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">

      <div class="notification-top text-center p-5 bg-primary text-white">
        <h3 class="text-white">{{ getUnseenNotificationLength }} New</h3>
        <p class="opacity-75">App Notifications</p>
      </div>

      <component :is="scrollbarTag" ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0 mb-10" :settings="settings" :key="$vs.rtl">
        <ul class="bordered-items">
          <li v-for="ntf in lastUnreadNotifications" :key="ntf.index" class="flex justify-between px-4 py-4 notification cursor-pointer"
              @click="redirectToCase(ntf, $event)">
            <div class="flex items-start">
              <feather-icon :icon="ntf.getIcon()" :svgClasses="[`text-${ntf.getColor()}`, 'stroke-current mr-1 h-6 w-6']"></feather-icon>
              <div class="flex flex-row mx-2">
                <span class="font-bold px-2"> #{{ ntf.caseId }} </span>
                <span class="text-sm block notification-title" :class="[`text-${ntf.getColor()}`]">
                  {{ $t(`pages.notifications.titleList.${ntf.eventType}`) }}
                </span>
              </div>
            </div>
            <small class="mt-1 whitespace-no-wrap">{{ elapsedTime(ntf.createdAt) }}</small>
          </li>
        </ul>
      </component>

      <div class="
        checkout-footer
        fixed
        bottom-0
        rounded-b-lg
        text-primary
        w-full
        p-2
        font-semibold
        text-center
        border
        border-b-0
        border-l-0
        border-r-0
        border-solid
        d-theme-border-grey-light
        cursor-pointer" @click="$router.push({name: 'notifications'})">
        <span>View All Notifications</span>
      </div>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import NotificationService from "@/services/Notification.service";
import {setTimeoutAsync} from '@/helpers/functionsHelpers';

export default {
  components: {
    VuePerfectScrollbar
  },
  data() {
    return {
      loaded: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60,
      },
    }
  },
  computed: {
    scrollbarTag() { return this.$store.getters.scrollbarTag },
    getUnseenNotificationLength() {
      return this.$store.getters['Notifications/getUnseenNotificationLength'];
    },
    lastUnreadNotifications() {
      return this.$store.getters['Notifications/getLastUnreadNotifications'](5);
    },
  },
  methods: {
    elapsedTime(startTime) {
      let x        = new Date(startTime)
      let now      = new Date()
      var timeDiff = now - x
      timeDiff    /= 1000

      var seconds = Math.round(timeDiff)
      timeDiff    = Math.floor(timeDiff / 60)

      var minutes = Math.round(timeDiff % 60)
      timeDiff    = Math.floor(timeDiff / 60)

      var hours   = Math.round(timeDiff % 24)
      timeDiff    = Math.floor(timeDiff / 24)

      var days    = Math.round(timeDiff % 365)
      timeDiff    = Math.floor(timeDiff / 365)

      var years   = timeDiff

      if (years > 0) {
        return years + (years > 1 ? ' Years ' : ' Year ') + 'ago'
      } else if (days > 0) {
        return days + (days > 1 ? ' Days ' : ' Day ') + 'ago'
      } else if (hours > 0) {
        return hours + (hours > 1 ? ' Hrs ' : ' Hour ') + 'ago'
      } else if (minutes > 0) {
        return minutes + (minutes > 1 ? ' Mins ' : ' Min ') + 'ago'
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? ' sec ago' : 'just now')
      }

      return 'Just Now'
    },
    getNotifications() {
      const func_cb = () => {
        return NotificationService.last5Notifications().then((response) => {
          this.$store.dispatch('Notifications/setLast5Notifications', response.notifications);
          this.$store.dispatch('Notifications/setTotalNotifications', response.totalNtf);
          this.$store.dispatch('Notifications/setStatusCaseNotifications', response.caseNtf);
          this.getNotifications();
          return Promise.resolve(true);
        });
      }

      return setTimeoutAsync(func_cb, process.env.VUE_APP_NOTIFICATION_POOLING_TIMEOUT * 1000);
    },
    redirectToCase(ntf, evt) {
      this.$router.push(ntf.path).catch(() => {});
      this.$refs.notificationMenu.toggleMenu('out', evt);
    }
  },
  mounted() {
    this.getNotifications().then(() => {
      this.loaded = true;
    });
  }
}

</script>

